export default __webpack_public_path__ + "static/design-tokens-nectar-example-54e4a8fa572294c61964583e0b0e0d19.png";